import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '../card-list.utils';

@Component({
  selector: 'nk-card-list-item-text',
  imports: [],
  templateUrl: './card-list-item-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemTextComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public text = computed(() => {
    const value = this.valueSignal();
    if (!value) {
      return null;
    }
    return value.entity[value.prop];
  });
}
